import React, { useState } from 'react';
import { OverlayTrigger, Tooltip, Modal } from 'react-bootstrap';
import { HelpCircle } from 'lucide-react';

interface HelpIconProps {
  htmlContent: string; // HTML string
  title?: string;
  size?: number;
  placement?: 'top' | 'bottom' | 'left' | 'right';
}

const HelpIcon: React.FC<HelpIconProps> = ({
  htmlContent,
  title = 'Help',
  size = 20,
  placement = 'top',
}) => {
  const [showModal, setShowModal] = useState(false);
  const isMobile = window.innerWidth < 576;

  const handleClick = () => {
    if (isMobile) {
      setShowModal(true);
    }
  };

  const tooltip = (
    <Tooltip id={`tooltip-${title}`} className='help-tooltip'>
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </Tooltip>
  );

  return (
    <>
      {isMobile ? (
        <HelpCircle
          size={size}
          style={{ cursor: 'pointer' }}
          onClick={handleClick}
        />
      ) : (
        <OverlayTrigger placement={placement} overlay={tooltip}>
          <HelpCircle size={size} style={{ cursor: 'pointer' }} />
        </OverlayTrigger>
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default HelpIcon;
